import React from 'react'

import './breadcrumbs.css'

export const Breadcrumbs = ({ post, isCenter=false }) => {
    return (
        <div className={`breadcrumbs${post.isHeaderDark ? ' dim':' bright'}`}>
            <ul className={isCenter ? 'justify-center':'justify-start'}>
                <li><a href='/' rel='nofollow noopener noreferrer'>Home</a><span>/</span></li>
                <li><a href={`/${post.parentCategory.slugId}/`}>{post.parentCategory.categoryName}</a><span>/</span></li>
                <li>{post.title}<span>/</span></li>
            </ul>
        </div>
    )
}